import { useRouter } from 'next/router';

import { getIsInputFormDisabled } from '../components/MFAccordion/utils';
import { useFeedOverrideSectionEnabled } from './useFeedOverrideSectionEnabled';

import type {
  FeedOverrideSection,
  GetUserPropertyDetailsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

/**
 * Section-aware variant of getIsInputFormDisabled: a feed listing's inputs unlock when the given
 * feed-override section is enabled (behind the feed-overrides feature flag); all other
 * restrictions (permissions, archived, update-restricted, onboarding) still apply.
 */
export const useIsInputFormDisabled = (
  listingDetails: GetUserPropertyDetailsResponseWebDto | undefined,
  canUpdateListing: boolean,
  section: FeedOverrideSection,
): boolean => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const isFeedOverrideEnabled = useFeedOverrideSectionEnabled(listingAlias, section);

  return getIsInputFormDisabled(listingDetails, canUpdateListing, { isFeedOverrideEnabled });
};
